export enum LanguageEnum {
    SPA = 'SPA',
    ENG = 'ENG',
    POR = 'POR'
}
